import { render } from "./CatalogueCard.vue?vue&type=template&id=ef37144c"
import script from "./CatalogueCard.vue?vue&type=script&lang=js"
export * from "./CatalogueCard.vue?vue&type=script&lang=js"

import "./CatalogueCard.vue?vue&type=style&index=0&id=ef37144c&lang=scss"
script.render = render

export default script